import React, { useState } from 'react';

import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Input } from '@/components/atoms/input';
import { KimMode } from '@/types';

interface QuestionInputProps {
  onSubmit: (question: string, mode: KimMode) => void;
  placeholder?: string;
}

const QuestionInput: React.FC<QuestionInputProps> = ({
  onSubmit,
  placeholder = 'Ask Kim a question about this case...',
}) => {
  const [question, setQuestion] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    if (question.trim()) {
      onSubmit(question, KimMode.QuestionFlow);
      setQuestion('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div className="relative flex items-center">
      <Input
        type="text"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="w-full rounded-lg border border-gray-300 px-4 py-3 pr-12 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
      />
      <button
        onClick={handleSubmit}
        className="bg-brandSecondary hover:bg-brandSecondary-hover absolute right-2 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full px-[9px] py-2 text-sm font-semibold text-white disabled:bg-gray-500"
      >
        <FontAwesomeIcon icon={faArrowRight} className="text-white" />
      </button>
    </div>
  );
};

export default QuestionInput;
